import { Table } from "antd";
import { Trash2 } from "react-feather";

import FormattedInput, {
  formatCurrencyInput,
  formatWholeNumberInput,
} from "../../CommonComponents/FormattedInput/FormattedInput";
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import { SGP_LEAGUE_DEFAULT_LIMIT_SOURCE } from "../../../queries/sportsbook/sgpLimits";
import styles from "./SGPLimits.module.css";

function buildEditableColumns({
  columns,
  editableField,
  editableValueType,
  currencySymbol,
  onFieldChange,
  onClearLeagueLimit,
  clearingLeagueId,
}) {
  const labelField = columns[0]?.dataIndex;
  const formatter =
    editableValueType === "currency"
      ? (value) => formatCurrencyInput(value, currencySymbol)
      : editableValueType === "whole-number"
        ? formatWholeNumberInput
        : undefined;

  return columns.map((column) => {
    if (column.dataIndex !== editableField) {
      return {
        ...column,
        sorter: undefined,
      };
    }

    return {
      ...column,
      sorter: undefined,
      render: (value, record, rowIndex) => {
        const canClearLeagueLimit =
          Boolean(onClearLeagueLimit) &&
          record.limitSource === SGP_LEAGUE_DEFAULT_LIMIT_SOURCE;
        const isClearing = clearingLeagueId === record.id;

        return (
          <div className={styles["sgp-limits-edit-field"]}>
            <FormattedInput
              type="text"
              inputMode={formatter ? "decimal" : undefined}
              className={styles["sgp-limits-edit-field-input"]}
              value={formatter ? formatter(value) : value}
              formatter={formatter}
              onChange={(nextValue) =>
                onFieldChange?.(record.id, column.dataIndex, nextValue)
              }
              aria-label={`${record[labelField]} ${column.title}`}
              autoFocus={rowIndex === 0}
              disabled={isClearing}
            />
            {canClearLeagueLimit ? (
              <div className={styles["sgp-limits-edit-clear-action"]}>
                <button
                  type="button"
                  className={styles["sgp-limits-limit-clear-button"]}
                  aria-label={`Reset ${record.league} default SGP combo limit`}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => onClearLeagueLimit(record)}
                  disabled={isClearing}
                  aria-busy={isClearing}
                >
                  {isClearing ? (
                    <RebetLoader height="14px" width="14px" />
                  ) : (
                    <Trash2 size={14} />
                  )}
                </button>
              </div>
            ) : null}
          </div>
        );
      },
    };
  });
}

function SGPLimitsTable({
  tableKey,
  columns,
  rows,
  isEditing = false,
  editableField,
  editableValueType,
  currencySymbol,
  onFieldChange,
  onClearLeagueLimit,
  clearingLeagueId,
}) {
  const renderedColumns = isEditing
    ? buildEditableColumns({
        columns,
        editableField,
        editableValueType,
        currencySymbol,
        onFieldChange,
        onClearLeagueLimit,
        clearingLeagueId,
      })
    : columns;

  return (
    <div className={styles["sgp-limits-table-shell"]} data-testid={`${tableKey}-table`}>
      <Table
        className={styles["sgp-limits-table"]}
        columns={renderedColumns}
        dataSource={rows}
        pagination={false}
        rowKey="id"
        tableLayout="fixed"
        showSorterTooltip={false}
        onRow={(record) => ({
          "data-testid": `${tableKey}-row-${record.id}`,
        })}
      />
    </div>
  );
}

export default SGPLimitsTable;
